import TestProvocativiEdit from "./components/TestProvocativiEdit.vue";
import TestProvocativiView from "./components/TestProvocativiView.vue";
import TestProvocativiList from "./components/TestProvocativiList.vue";

export default {
    TestProvocativiEdit,
    TestProvocativiView,
    TestProvocativiList,
};
